// The days an account uses the site (2 Nov 2026), for the admin dashboard's active days and retention by sign-up
// week, as greeksoup.ai keeps them. While a signed-in tab is open, the site tells the worker once a day per browser
// (cloudflare/admin.mjs handleActiveDay), which keeps the account id and the India day for 90 days. Nothing else
// is sent. The browser remembers the last day it told, so a day costs one request however many tabs are open.
const KEY = "sn-active-day";
const indiaDay = () => new Date(Date.now() + 5.5 * 3600000).toISOString().slice(0, 10);

export function noteActiveDay(token: string | undefined, userId: string | undefined) {
  try {
    if (!token || !userId || document.hidden) return;
    const mark = userId + ":" + indiaDay();
    if (localStorage.getItem(KEY) === mark) return;
    // marked only once the worker has it, so a failed send is tried again on the next check
    fetch("/api/data/active-day", { method: "POST", headers: { Authorization: `Bearer ${token}` } })
      .then((r) => { if (r.ok) localStorage.setItem(KEY, mark); }).catch(() => {});
  } catch { /* storage refused: nothing sent */ }
}
